<template>
  <div class="app-container">
    <el-tabs @tab-click="handleClick" v-model="activeName">
      <el-tab-pane
        :label="item.name"
        :name="item.id"
        v-for="(item, index) in qiyeList"
        :key="index + 'qiye'"
      ></el-tab-pane>
    </el-tabs>
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="90px">
      <el-form-item label="所属部门" prop="deptId">
        <el-select style="width: 100%" v-model="queryParams.deptId" placeholder="请选择所属部门" clearable filterable>
          <el-option
            v-for="item in deptList"
            :key="item.deptId + 'deptId'"
            :label="item.deptName"
            :value="item.deptId"
            v-show="item.parentId != 0 && item.parentId != 100"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入打卡人姓名"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>

      <el-form-item label="联系人电话" prop="phone">
        <el-input
          v-model="queryParams.phone"
          placeholder="请输入联系人电话"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <!-- <el-form-item label="打卡时间">
        <el-date-picker
          v-model="queryParams.time"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="请选择打卡时间"
        ></el-date-picker>
      </el-form-item> -->
      <el-form-item label="打卡时间">
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
        ></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="打卡时间" prop="time">
        <el-input
          v-model="queryParams.time"
          placeholder="请输入联系人电话"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8" style="margin-bottom: 10px">
      <!-- <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['system:company:add']"
        >新增</el-button>
      </el-col> -->
      <el-col :span="1.5" v-if="dateRange.length > 0 && dateRange.length != null">
        <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <!-- <el-table v-loading="loading" :data="companyList">
      <el-table-column label="员工信息" align="center" prop="deptName">
        <el-table-column prop="name" label="姓名" width="120"> </el-table-column>
        <el-table-column prop="name" label="部门" width="120"> </el-table-column>
        <el-table-column prop="name" label="工号" width="120"> </el-table-column>
        <el-table-column prop="name" label="职位" width="120"> </el-table-column>
      </el-table-column>
      <el-table-column label="打卡时间" align="center" prop="name" />
    </el-table> -->
    <!-- <div>
      <div class="bordered-box">
        <div class="bordered-box-1" style="width: 543px">员工信息</div>
        <div class="bordered-box-1" style="width: calc(100% - 545px)">打卡时间</div>
      </div>
      <div>
        <div style="display: flex">
          <div class="bordered-box" style="width: 553px">
            <div class="bordered-box-1">姓名</div>
            <div class="bordered-box-1">部门</div>
            <div class="bordered-box-1">工号</div>
            <div class="bordered-box-1">职位</div>
          </div>
          <div class="bordered-box1" style="width: calc(100% - 545px)">
            <div class="bordered-box-1" v-for="(item, index) in companyList" :key="index + 'aa'">{{ item }}</div>
          </div>
        </div>
        <div>
          <div class="bordered-box" v-for="(item, index) in statValueList" :key="index + 'aa'">
            <div
              :class="indexs < 4 ? 'bordered-box-1' : 'bordered-box-2'"
              v-for="(items, indexs) in item"
              :key="indexs + 'cc'"
              :style="indexs < 4 ? 'width:100px;' : 'width:100%;'"
            >
              <div style="white-space: pre-line">
                {{ items }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="table-container">
      <table class="bordered-table">
        <thead>
          <tr>
            <th :colspan="4" class="col-fixed" style="width: 300px">员工信息</th>
            <th :colspan="companyList.length">打卡时间</th>
          </tr>
          <tr>
            <td class="col-fixed" style="width: 120px; z-index: 9">姓名</td>
            <td class="col-fixed" style="width: 120px; z-index: 9">部门</td>
            <td class="col-fixed" style="width: 120px; z-index: 9">工号</td>
            <td class="col-fixed" style="width: 120px; z-index: 9">职位</td>
            <td v-for="(item, index) in companyList" :key="index + 'aa'">{{ item }}</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in statValueList" :key="index + 'bb'">
            <td
              v-for="(items, indexs) in item"
              :key="indexs + 'cc'"
              :class="indexs < 4 ? 'col-fixed' : ''"
              style="white-space: pre-line"
            >
              {{ trimSpaces(items) }}
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <table class="bordered-table">
        <thead>
          <tr>
            <th :colspan="4" class="col-fixed">员工信息</th>
          </tr>
          <tr>
            <td class="col-fixed">姓名</td>
            <td class="col-fixed">部门</td>
            <td class="col-fixed">工号</td>
            <td class="col-fixed">职位</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in statValueList" :key="index + 'bb'">
            <td v-for="(items, indexs) in item.slice(0, 4)" :key="indexs + 'cc'" :class="indexs < 4 ? 'col-fixed' : ''">
              {{ items }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="bordered-table">
        <thead>
          <tr>
            <th :colspan="companyList.length" class="col-fixed">打卡时间</th>
          </tr>
          <tr>
            <td v-for="(item, index) in companyList" :key="index + 'aa'">{{ item }}</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in statValueList" :key="index + 'bb'">
            <td v-for="(items, indexs) in item.slice(4)" :key="indexs + 'cc'" :class="indexs < 4 ? 'col-fixed' : ''">
              {{ items }}
            </td>
          </tr>
        </tbody>
      </table> -->
    </div>

    <!-- <pagination
      v-show="total > 0"
      :total="Number(total)"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    /> -->

    <!--新增编辑界面-->
    <el-drawer
      :title="title"
      :visible.sync="open"
      :before-close="handleClose"
      destroy-on-close
      class="headerts editdrawer"
      size="30%"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        style="padding-right: 30px"
        :disabled="title == '查看公司'"
      >
        <el-col :span="24">
          <el-form-item label="公司名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入公司名称" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="联系人姓名" prop="contactName">
            <el-input v-model="form.contactName" placeholder="请输入联系人姓名" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="联系人电话" prop="contactPhone">
            <el-input v-model="form.contactPhone" placeholder="请输入联系人电话" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="公司地址" prop="address">
            <el-input v-model="form.address" placeholder="请输入公司地址" />
          </el-form-item>
        </el-col>
      </el-form>
      <div class="dialog-footer" v-if="title !== '查看公司'">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { unlockRecordDayList, unlockRecordStatistics } from '@/api/clockIn'
import axios from 'axios'

export default {
  name: 'Company',
  data() {
    return {
      EId: this.$route.query.EId,
      url: this.$route.query.url,
      platformId: this.$route.query.platformId,
      activeName: '',
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 公司表格数据
      companyList: [],
      statValueList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        contactName: null,
        contactPhone: null,
        address: null,
        firstDay: undefined,
        lastDay: undefined,
        deptId: undefined,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        name: [
          {
            required: true,
            message: '请选择输入正确公司名称',
            trigger: 'blur',
          },
        ],
        contactName: [
          {
            required: true,
            message: '请选择输入正确联系人姓名',
            trigger: 'blur',
          },
        ],
        contactPhone: [
          {
            required: true,
            message: '请选择输入正确联系人电话',
            trigger: 'blur',
          },
        ],
        address: [{ required: true, message: '请输入正确公司地址', trigger: 'blur' }],
      },
      // 日期范围
      dateRange: [],
      deptList: [],
      qiyeList: [],
    }
  },
  created() {
    this.getQiyeList()
    // console.log(this.getFirstDayOfMonth(), this.getCurrentDate())
    this.dateRange = [this.getFirstDayOfMonth(), this.getCurrentDate()]
    // this.getList()
  },
  methods: {
    // 获取企业列表
    getQiyeList() {
      if (this.$route.query.EId == 'null') {
        var EId = null
      } else {
        var EId = this.$route.query.EId
      }
      axios({
        // url: this.url + "/OA/getUserList",
        url: this.url + '/system/company/listOut',
        method: 'get',
        params: {
          platformId: this.$route.query.platformId,
          id: EId,
          pageSize: 999,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.activeName = res.data.rows[0].id
          this.qiyeList = res.data.rows
          this.getDeptList(this.activeName)
          this.queryParams.companyId = this.activeName
          this.getList()
        }
      })
    },
    // 企业切换
    handleClick(e) {
      console.log(e)
      this.queryParams.deptId = null
      this.getDeptList(e.name)
      this.queryParams.companyId = e.name
      this.getList()
    },
    getDeptList(companyId) {
      console.log(companyId)
      axios({
        // url: this.url + "/OA/getUserList",
        url: this.url + '/system/dept/list',
        method: 'get',
        params: {
          platformId: this.$route.query.platformId,
          companyId: companyId,
          pageSize: 999,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.deptList = res.data.data
        }
      })
    },
    trimSpaces(val) {
      if (val != null && val != '') {
        return val.replace(/^\s+|\s+$/g, '').trim()
      }
    },
    // 获取本月第一天
    getFirstDayOfMonth() {
      let date = new Date()
      date.setDate(1)
      return `${date.getFullYear()}-${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}-${
        date.getDate() < 10 ? '0' : ''
      }${date.getDate()}`
    },

    // 获取当前日期
    getCurrentDate() {
      let date = new Date()
      return `${date.getFullYear()}-${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}-${
        date.getDate() < 10 ? '0' : ''
      }${date.getDate()}`
    },

    /** 查询表头 */
    getList() {
      this.loading = true
      if (this.dateRange != null) {
        if (this.dateRange.length != 0) {
          this.queryParams.firstDay = this.dateRange[0]
          this.queryParams.lastDay = this.dateRange[1]
        } else {
          this.queryParams.firstDay = undefined
          this.queryParams.lastDay = undefined
        }
      } else {
        this.queryParams.firstDay = undefined
        this.queryParams.lastDay = undefined
      }

      unlockRecordDayList(this.queryParams).then((response) => {
        if (response.code == 200) {
          this.companyList = response.data
          this.total = response.total
          this.loading = false
        }
      })
      unlockRecordStatistics(this.queryParams).then((response) => {
        if (response.code == 200) {
          this.statValueList = response.data
        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        name: null,
        contactName: null,
        contactPhone: null,
        address: null,
        createTime: null,
      }
      this.resetForm('form')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.title = '添加公司'
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      const id = row.id || this.ids
      getCompany(id).then((response) => {
        this.form = response.data
        this.open = true
        this.title = '修改公司'
      })
    },
    /** 查看按钮操作 */
    handleEdits(row) {
      this.reset()
      const id = row.id || this.ids
      getCompany(id).then((response) => {
        this.form = response.data
        this.open = true
        this.title = '查看公司'
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateCompany(this.form).then((response) => {
              this.$modal.msgSuccess('修改成功')
              this.open = false
              this.getList()
            })
          } else {
            addCompany(this.form).then((response) => {
              this.$modal.msgSuccess('新增成功')
              this.open = false
              this.getList()
            })
          }
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids
      this.$modal
        .confirm('是否确认删除公司编号为"' + ids + '"的数据项？')
        .then(function() {
          return delCompany(ids)
        })
        .then(() => {
          this.getList()
          this.$modal.msgSuccess('删除成功')
        })
        .catch(() => {})
    },
    /** 导出按钮操作 */
    handleExport() {
      if (this.dateRange.length != 0) {
        // this.queryParams.firstDay = this.dateRange[0]
        // this.queryParams.lastDay = this.dateRange[1]
        var firstDay = this.dateRange[0]
        var lastDay = this.dateRange[1]
      } else {
        var firstDay = undefined
        var lastDay = undefined
      }
      var params = {
        firstDay: firstDay,
        lastDay: lastDay,
        name: this.queryParams.name,
        phone: this.queryParams.phone,
        companyId: this.queryParams.companyId,
        deptId: this.queryParams.deptId,
      }
      this.download(
        'OA/unlockRecord/export',
        {
          ...params,
        },
        `考勤记录_${new Date().getTime()}.xlsx`
      )
    },
    // 弹框退出事件
    handleClose() {
      this.open = false
    },
  },
}
</script>

<style>
.dialog-footer {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
}
.bordered-box {
  text-align: center;
  display: flex;
  /* width: 100%; */
}
/* .bordered-box div {
  border: 1px solid #dfe6ec;
  padding: 8px;
  width: 120px;
} */
.bordered-box1 {
  text-align: center;
  display: flex;
  width: 100%;
}
.bordered-box-1 {
  border: 1px solid #dfe6ec;
  padding: 8px;
  min-width: 120px;
  width: 100%;
}
.bordered-box-2 {
  border: 1px solid #dfe6ec;
  padding: 8px;
  min-width: 120px;

  /* width: 100% !important; */
}
.table-container {
  width: 100%;
  height: 70vh;
  overflow-x: scroll !important;
  position: relative; /* 为了定位子元素 */
}

.bordered-table {
  width: 100%;
  text-align: center;
  border-collapse: collapse; /* 合并表格边框 */
  overflow-x: scroll !important;
  margin-bottom: 10px;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid #dfe6ec; /* 设置边框样式 */
  padding: 8px; /* 单元格内边距 */
  text-align: center; /* 文本对齐方式 */
  min-width: 90px;
  max-width: 100px;
}
.col-fixed {
  /* position: -webkit-sticky; */
  /* position: sticky;
  left: 0;
  background: #ffffff;
  z-index: 9;
  min-width: 90px; */
  /* border: 1px solid #263644 !important; */
}
/* .col-fixed:nth-child(2) {
  left: 105px; 
}
.col-fixed:nth-child(3) {
  left: 210px; 
}
.col-fixed:nth-child(4) {
  left: 315px; 
} */

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #e1e1e2;
}
::-webkit-scrollbar-thumb {
  background-color: #9a9a9a; /*rgba(0,0,0,1);*/
  border-radius: 10px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* .table-container th:nth-child(1),
.table-container td:nth-child(1) {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 9;
}
th:nth-child(2),
td:nth-child(2) {
  position: sticky;
  left: 100px;
  background-color: white;
  z-index: 1;
}
th:nth-child(3),
td:nth-child(3) {
  position: sticky;
  left: 200px;
  background-color: white;
  z-index: 1;
}
th:nth-child(4),
td:nth-child(4) {
  position: sticky;
  left: 300px;
  background-color: white;
  z-index: 1;
}
.scrollable {
  overflow-x: auto;
  overflow-y: hidden;
  height: 100px;
} */
</style>
